import { logClientError } from "./logging";

interface CrashContext {
  [key: string]: unknown;
}

// Reports to whichever sink is available: the desktop build logs locally via
// Electron (works even if the Flask backend never started), the web build
// posts to the backend's existing /api/logs/client endpoint.
export function reportCrash(message: string, stack?: string, context: CrashContext = {}) {
  logClientError("crash", message, { stack, ...context });

  void window.electronAPI?.reportCrash({ message, stack, context }).catch(() => undefined);
}

let installed = false;

// Catches errors React's own boundary can't: exceptions thrown outside render
// (event handlers, timers, promise chains) and rejected promises nobody awaited.
export function installGlobalCrashReporting() {
  if (installed || typeof window === "undefined") return;
  installed = true;

  window.addEventListener("error", (event) => {
    reportCrash(event.message, event.error?.stack, { kind: "window.onerror" });
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    const message = reason instanceof Error ? reason.message : String(reason);
    const stack = reason instanceof Error ? reason.stack : undefined;
    reportCrash(message, stack, { kind: "unhandledrejection" });
  });
}
